import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LngDetector from 'i18next-browser-languagedetector';

const en = require('../i18n/en.json');
const de = require('../i18n/de.json');

i18n.use(initReactI18next)
    .use(LngDetector)
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de },
        },
        // lng: 'en',
        keySeparator: '.',
        fallbackLng: 'en',
        whitelist: ['de', 'en', 'it', 'es'],
        interpolation: {
            escapeValue: false
        }
    });
export default i18n;